import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadLaborCostsInStoresInitialRoleBased } from "@/types/laborCostsInStoresInitial";

const LaborCostsInStoresInitialRoleBasedServiceAPI =
  new APIService<ReadLaborCostsInStoresInitialRoleBased>(
    API.InvoiceSpecifications,
  );

export const laborCostsInStoresInitialRoleBased = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadLaborCostsInStoresInitialRoleBased>,
  ) =>
    LaborCostsInStoresInitialRoleBasedServiceAPI.getList(
      fetchParams,
      `/initial/role-based-project/${settlementId}`,
    ),
};
